import { LicenseStatusNameMap, LicenseStatusValue, MspLicenseNameMap, MspLicensePriceMap, MspLicenseType, SelectOption } from "@core/types";

// Device License Action List
export const LICENSE_ACTION_LIST = {
	assign: {
		name: "Assign",
		icon: "icon-bookmark"
	},
	unclaim: {
		name: "Unclaim",
		icon: "icon-delete",
	},
	transfer: {
		name: "Transfer",
		icon: "icon-shuffle"
	},
	renew: {
		name: "Renew",
		icon: "icon-rotate-cw"
	},
	reclaim: {
		name: "Reclaim",
		icon: "icon-corner-left-up"
	}
	/* delete: {
		name: "Delete",
		icon: "icon-x-circle",
		alert: "Deleted license(s) will be gone forever. Are you sure you want to Delete the License(s)?"
	} */
};

// Device ISP Price Chart
export const TRIAL_PRICE_CHART = {
	'TRIAL-MO-5LP': { cost: 1501, total: 5 }
};

export const ISP_PRICE_CHART = {
	'ISP-MO-100LP': { cost: 125, total: 100 },
	'ISP-MO-200LP': { cost: 175, total: 200 },
	'ISP-MO-300LP': { cost: 250, total: 300 },
	'ISP-MO-400LP': { cost: 300, total: 400 },
	'ISP-MO-500LP': { cost: 350, total: 500 },
	'ISP-MO-1KLP': { cost: 400, total: 1000 },
	'ISP-MO-2KLP': { cost: 600, total: 2000 },
	'ISP-MO-3KLP': { cost: 750, total: 3000 },
	'ISP-MO-4KLP': { cost: 800, total: 4000 },
	'ISP-MO-5KLP': { cost: 850, total: 5000 },
	'ISP-MO-6KLP': { cost: 900, total: 6000 },
	'ISP-MO-7KLP': { cost: 950, total: 7000 },
	'ISP-MO-8KLP': { cost: 1000, total: 8000 },
	'ISP-MO-9KLP': { cost: 1150, total: 9000 },
	'ISP-MO-10KLP': { cost: 1250, total: 10000 },
	'ISP-MO-11KLP': { cost: 1350, total: 11000 },
	'ISP-MO-12KLP': { cost: 1450, total: 12000 },
	'ISP-MO-13KLP': { cost: 1550, total: 13000 },
	'ISP-MO-14KLP': { cost: 1650, total: 14000 },
	'ISP-MO-15KLP': { cost: 1750, total: 15000 },
	'ISP-MO-16KLP': { cost: 1850, total: 16000 },
	'ISP-MO-17KLP': { cost: 1950, total: 17000 },
	'ISP-MO-18KLP': { cost: 2050, total: 18000 },
	'ISP-MO-19KLP': { cost: 2150, total: 19000 },
	'ISP-MO-20KLP': { cost: 2250, total: 20000 },
	'ISP-MO-21KLP': { cost: 2350, total: 21000 },
	'ISP-MO-22KLP': { cost: 2450, total: 22000 },
	'ISP-MO-23KLP': { cost: 2550, total: 23000 },
	'ISP-MO-24KLP': { cost: 2650, total: 24000 },
	'ISP-MO-25KLP': { cost: 2750, total: 25000 },
	'ISP-MO-30KLP': { cost: 3250, total: 30000 },
	'ISP-MO-40KLP': { cost: 4250, total: 40000 },
	'ISP-MO-50KLP': { cost: 5250, total: 50000 },
};

export const ISP_PLUS_PRICE_CHART = {
	'ISP-MO-100LP': { cost: 150, total: 100 },
	'ISP-MO-200LP': { cost: 240, total: 200 },
	'ISP-MO-300LP': { cost: 300, total: 300 },
	'ISP-MO-400LP': { cost: 360, total: 400 },
	'ISP-MO-500LP': { cost: 420, total: 500 },
	'ISP-MO-1KLP': { cost: 480, total: 1000 },
	'ISP-MO-2KLP': { cost: 720, total: 2000 },
	'ISP-MO-3KLP': { cost: 900, total: 3000 },
	'ISP-MO-4KLP': { cost: 960, total: 4000 },
	'ISP-MO-5KLP': { cost: 1020, total: 5000 },
	'ISP-MO-6KLP': { cost: 1080, total: 6000 },
	'ISP-MO-7KLP': { cost: 1140, total: 7000 },
	'ISP-MO-8KLP': { cost: 1200, total: 8000 },
	'ISP-MO-9KLP': { cost: 1380, total: 9000 },
	'ISP-MO-10KLP': { cost: 1600, total: 10000 },
	'ISP-MO-11KLP': { cost: 1700, total: 11000 },
	'ISP-MO-12KLP': { cost: 1800, total: 12000 },
	'ISP-MO-13KLP': { cost: 1900, total: 13000 },
	'ISP-MO-14KLP': { cost: 2000, total: 14000 },
	'ISP-MO-15KLP': { cost: 2100, total: 15000 },
	'ISP-MO-16KLP': { cost: 2200, total: 16000 },
	'ISP-MO-17KLP': { cost: 2300, total: 17000 },
	'ISP-MO-18KLP': { cost: 2400, total: 18000 },
	'ISP-MO-19KLP': { cost: 2500, total: 19000 },
	'ISP-MO-20KLP': { cost: 2600, total: 20000 },
	'ISP-MO-21KLP': { cost: 2700, total: 21000 },
	'ISP-MO-22KLP': { cost: 2800, total: 22000 },
	'ISP-MO-23KLP': { cost: 2900, total: 23000 },
	'ISP-MO-24KLP': { cost: 3000, total: 24000 },
	'ISP-MO-25KLP': { cost: 3100, total: 25000 },
	'ISP-MO-30KLP': { cost: 4100, total: 30000 },
	'ISP-MO-40KLP': { cost: 5100, total: 40000 },
	'ISP-MO-50KLP': { cost: 6100, total: 50000 },
};

export const TRIAL_LICENSE_PLAN: Array<SelectOption> = [
	{ name: 'TRIAL-MO-5LP', value: 5 }
];

export const ISP_LICENSE_PLAN: Array<SelectOption> = [
	{ name: 'ISP-MO-100LP', value: 100 },
	{ name: 'ISP-MO-200LP', value: 200 },
	{ name: 'ISP-MO-300LP', value: 300 },
	{ name: 'ISP-MO-400LP', value: 400 },
	{ name: 'ISP-MO-500LP', value: 500 },
	{ name: 'ISP-MO-1KLP', value: 1000 },
	{ name: 'ISP-MO-2KLP', value: 2000 },
	{ name: 'ISP-MO-3KLP', value: 3000 },
	{ name: 'ISP-MO-4KLP', value: 4000 },
	{ name: 'ISP-MO-5KLP', value: 5000 },
	{ name: 'ISP-MO-6KLP', value: 6000 },
	{ name: 'ISP-MO-7KLP', value: 7000 },
	{ name: 'ISP-MO-8KLP', value: 8000 },
	{ name: 'ISP-MO-9KLP', value: 9000 },
	{ name: 'ISP-MO-10KLP', value: 10000 },
	{ name: 'ISP-MO-11KLP', value: 11000 },
	{ name: 'ISP-MO-12KLP', value: 12000 },
	{ name: 'ISP-MO-13KLP', value: 13000 },
	{ name: 'ISP-MO-14KLP', value: 14000 },
	{ name: 'ISP-MO-15KLP', value: 15000 },
	{ name: 'ISP-MO-16KLP', value: 16000 },
	{ name: 'ISP-MO-17KLP', value: 17000 },
	{ name: 'ISP-MO-18KLP', value: 18000 },
	{ name: 'ISP-MO-19KLP', value: 19000 },
	{ name: 'ISP-MO-20KLP', value: 20000 },
	{ name: 'ISP-MO-21KLP', value: 21000 },
	{ name: 'ISP-MO-22KLP', value: 22000 },
	{ name: 'ISP-MO-23KLP', value: 23000 },
	{ name: 'ISP-MO-24KLP', value: 24000 },
	{ name: 'ISP-MO-25KLP', value: 25000 },
	{ name: 'ISP-MO-30KLP', value: 30000 },
	{ name: 'ISP-MO-40KLP', value: 40000 },
	{ name: 'ISP-MO-50KLP', value: 50000 }
]

export const TENANT_ACCOUNT_TYPES = [
	{ name: "Enterprise(MSP/Partner)", value: "partner" },
	{ name: "Standard", value: "ISP" },
	{ name: "Plus", value: "ISP-Plus" },
	{ name: "Pro", value: "ISP-Pro" },
	{ name: "Trial", value: "trial" }
];

export const MSP_LICENSE_TYPE_NAME_MAP: MspLicenseNameMap = {
	[MspLicenseType.TRIAL]: "Trial",
	[MspLicenseType.ONE_YEAR]: "One Year",
	[MspLicenseType.TWO_YEARS]: "Two Years",
	[MspLicenseType.THREE_YEARS]: "Three Years",
	[MspLicenseType.FIVE_YEARS]: "Five Years"
};

export const MSP_LICENSE_PRICE_MAP: MspLicensePriceMap = {
	[MspLicenseType.TRIAL]: 0,
	[MspLicenseType.ONE_YEAR]: 45.00,
	[MspLicenseType.TWO_YEARS]: 90.00,
	[MspLicenseType.THREE_YEARS]: 135.00,
	[MspLicenseType.FIVE_YEARS]: 225.00
};

export const MSP_LICENSE_COUNTING_NAME: Array<any> = [
	{ name: MSP_LICENSE_TYPE_NAME_MAP[MspLicenseType.TRIAL], key: "availableTrial", badgeClass: 'badge-light-danger' },
	{ name: MSP_LICENSE_TYPE_NAME_MAP[MspLicenseType.ONE_YEAR], key: "availableOneYear", badgeClass: 'badge-light-warning' },
	{ name: MSP_LICENSE_TYPE_NAME_MAP[MspLicenseType.TWO_YEARS], key: "availableTwoYears", badgeClass: 'badge-light-primary' },
	{ name: MSP_LICENSE_TYPE_NAME_MAP[MspLicenseType.THREE_YEARS], key: "availableThreeYears", badgeClass: 'badge-light-success' },
	{ name: MSP_LICENSE_TYPE_NAME_MAP[MspLicenseType.FIVE_YEARS], key: "availableFiveYears", badgeClass: 'badge-light-info' }
];

export const LICENSE_STATUS_NAME : LicenseStatusNameMap = {
	[LicenseStatusValue.NEW]: "New",
	[LicenseStatusValue.ACTIVE]: "Active",
	[LicenseStatusValue.INACTIVE]: "Unassigned",
	[LicenseStatusValue.EXPIRED]: "Expired"
};